(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Step', Step);

    Step.$inject = ['$resource'];

    function Step ($resource) {
        var resourceUrl =  'api/steps/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
